import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PaginationCustomization extends MatPaginatorIntl implements OnDestroy {
    subscription: Subscription;

    constructor(private translateService: TranslateService) {
        super();
        this.subscription = this.translateService.onLangChange.subscribe((e: Event) => {
            this.getTranslations();
        });

        this.getTranslations();
    }

    getTranslations() {
        this.itemsPerPageLabel = this.translateService.instant('Pagination.ItemsPerPageLabel');
        this.nextPageLabel = this.translateService.instant('Pagination.NextPageLabel');
        this.previousPageLabel = this.translateService.instant('Pagination.PreviousPageLabel');
        this.firstPageLabel = this.translateService.instant('Pagination.FirstPageLabel');
        this.lastPageLabel = this.translateService.instant('Pagination.LastPageLabel');
        this.changes.next();
    }

    override getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return '0 ' + this.translateService.instant('Pagination.Of') + ' ' + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return startIndex + 1 + ' - ' + endIndex + ' ' + this.translateService.instant('Pagination.On') + ' ' + length;
    };

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
